import * as React from "react";
import {
  DropDownList,
} from "@progress/kendo-react-dropdowns";
import { GridCellProps } from "@progress/kendo-react-grid";
import * as CONSTANTS from "../../utils/CONSTANTS";
import { checkFunctionality } from "../../utils/EllowUtils";
import classnames from "classnames";

export const DropDown = (props: GridCellProps, getTableValues?: any) => {
  
  const userLoginId = localStorage.getItem('loginId')
  const { dataItem } = props;
  const field = props.field || '';
  
  const dataValue = dataItem[field] === null ? '' : dataItem[field];

  const selectDropdown = (fieldName: string) => {    
    let valueData = [];
    
    switch (fieldName) {
      case "availability":
        return (valueData = CONSTANTS.localizedData);
      
      case "priority":
        return (valueData = CONSTANTS.localizedData3);
      
      default:
        return(valueData = CONSTANTS.localizedData2)
    }
  }

  const checkPriorityColour = (name: string, data: any) => {
   let value = checkFunctionality(field, dataValue)
   switch (value){
     case 'Hot':
       return 'Red'
     case 'Warm':
       return 'Yellow'
     case 'Cold':
       return 'Blue'
     default: 
       return 'Blue'
   }
 }
 
  
    return (
      <td>
        { dataItem && dataItem.inEdit ? (
          <DropDownList
            style={{ width: "100%" }}
            value={selectDropdown(field).find((c: { value: any; }) => c.value === dataValue)}
            data={selectDropdown(field)}
            textField="text"
                />
            ) : (
          field !== 'priority' ? <div className="wordBreak">{dataValue && checkFunctionality(field, dataValue)}</div> : 
          <div className={classnames(checkPriorityColour(field, dataValue,) + " statusMessage")}>{dataValue && checkFunctionality(field, dataValue)}</div>
          )
          }
      </td>
    );
}
